import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { DateComponent } from '../../../components/DateComponent';
import { StatusBadge } from '../../../components/status/StatusBadge';
import { UploadedDocument } from '../../../interfaces/merchant';
import { parseContentTypeToReadableFormat } from '../../../utils/utilities';

export enum DocumentsTableAccessorKeys {
  fileName = 'name',
  format = 'type',
  // size = 'size',
  // uploadedBy = 'uploadedBy',
  uploadedDate = 'createdOn',
}

export const defaultDocumentsColumnSizing: ColumnSizing = {
  [DocumentsTableAccessorKeys.fileName]: 100,
  [DocumentsTableAccessorKeys.format]: 10,
  // [DocumentsTableAccessorKeys.size]: 10,
  // [DocumentsTableAccessorKeys.uploadedBy]: 50,
  [DocumentsTableAccessorKeys.uploadedDate]: 50,
};

export const defaultDocumentsColumns: MRT_ColumnDef<UploadedDocument>[] = [
  {
    accessorKey: DocumentsTableAccessorKeys.fileName,
    header: 'File name',
    enableSorting: false,
    Header: <span className="text-muted fw-bolder main-font-family">File name</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black fs-7"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        {renderedCellValue ? renderedCellValue : '-'}
      </TableCell>
    )
  },
  {
    accessorKey: DocumentsTableAccessorKeys.format,
    header: 'Format',
    enableSorting: false,
    Header: <span className="text-muted fw-bolder main-font-family">Format</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black fs-7"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        <StatusBadge status={parseContentTypeToReadableFormat(renderedCellValue)}/>
      </TableCell>
    )
  },
  // {
  //   accessorKey: DocumentsTableAccessorKeys.size,
  //   header: 'Size',
  //   enableSorting: false,
  //   Header: <span className="text-muted fw-bolder main-font-family">Size</span>,
  //   Cell: ({ renderedCellValue, table }: any): JSX.Element => (
  //     <TableCell
  //       additionalClass="main-font-family text-black fs-7"
  //       density={table?.options?.state?.density}
  //       isTextOverflow={false}
  //     >
  //       {renderedCellValue ? `${renderedCellValue} MB` : '-'}
  //     </TableCell>
  //   )
  // },
  // {
  //   accessorKey: DocumentsTableAccessorKeys.uploadedBy,
  //   header: 'Uploaded by',
  //   enableSorting: false,
  //   Header: <span className="text-muted fw-bolder main-font-family">Uploaded by</span>,
  //   Cell: ({ renderedCellValue, table }: any): JSX.Element => (
  //     <TableCell
  //       additionalClass="main-font-family text-black fs-7"
  //       density={table?.options?.state?.density}
  //       isTextOverflow={false}
  //     >
  //       {renderedCellValue ? renderedCellValue : '-'}
  //     </TableCell>
  //   )
  // },
  {
    accessorKey: DocumentsTableAccessorKeys.uploadedDate,
    header: 'Uploaded date',
    enableSorting: false,
    Header: <span className="text-muted fw-bolder main-font-family">Uploaded date</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black fs-7"
        density={table?.options?.state?.density}
        isTextOverflow={false}
      >
        <DateComponent
          value={renderedCellValue}
          isTime
        />
      </TableCell>
    )
  },
];
